import { ADVERT_TOP_CARS } from '../constants/actionTypes';

const initialState = null;

const advertTopCars = (state = initialState, action) => {
  switch (action.type) {
    case ADVERT_TOP_CARS.SET:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default advertTopCars;



// WEBPACK FOOTER //
// ./src/shared/reducers/advertTopCars.js